import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Polyline, { points: "14.5 17.5 3 6 3 3 6 3 17.5 14.5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "13", x2: "19", y1: "19", y2: "13", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "16", x2: "20", y1: "16", y2: "20", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "19", x2: "21", y1: "21", y2: "19", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Polyline, { points: "14.5 6.5 18 3 21 3 21 6 17.5 9.5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "5", x2: "9", y1: "14", y2: "18", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "7", x2: "4", y1: "17", y2: "20", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "3", x2: "5", y1: "19", y2: "21", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Swords";
const Swords = memo(themed(Icon));
export {
  Swords
};
//# sourceMappingURL=swords.js.map
